import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { DeliveryNoteEndpoint } from '../../constants/delivery-note-endpoint';
import { DeliveryNoteOverview, DeliveryNoteParams } from '../../models/delivery-note.model';
import { Tracking } from '../../../../models/monitoring-tracking';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class DeliveryNoteOverviewService {
  constructor(private http: WrapperHttpService) {}

  getOverviewData({ deliveryNoteNumber, sapId }: DeliveryNoteParams): Observable<DeliveryNoteOverview> {
    const params = sapId ? `?${getQueryStringFromObject({ sapId })}` : '';

    return this.http
      .withLoading()
      .get<DeliveryNoteOverview>(
        `${API_URL}${DeliveryNoteEndpoint.Base}${DeliveryNoteEndpoint.Monitoring}${DeliveryNoteEndpoint.DeliveryNote}/${deliveryNoteNumber}${DeliveryNoteEndpoint.Overview}${params}`,
      );
  }

  getTracking({ deliveryNoteNumber, sapId }: DeliveryNoteParams): Observable<Tracking[]> {
    const params = sapId ? `?${getQueryStringFromObject({ sapId })}` : '';

    return this.http
      .withLoading()
      .get<Tracking[]>(
        `${API_URL}${DeliveryNoteEndpoint.Base}${DeliveryNoteEndpoint.Monitoring}${DeliveryNoteEndpoint.DeliveryNote}/${deliveryNoteNumber}${DeliveryNoteEndpoint.Statuses}${params}`,
      );
  }
}
